import { useEffect, useState, useRef } from 'react';
import { any, string, array, oneOfType, bool } from 'prop-types';
import TrackingHelper from 'src/utils/trackingHelper';
import {
  StyledMobileMenu,
  StyledTrigger,
  StyledCancelTrigger,
  StyledIconTrigger,
  StyledMobileMenuBody,
  StyledInfoContainer,
  StyledPrimaryInfo,
  StyledSecondaryInfo,
  StyledIconAction,
  StyledLabel,
  StyledLink,
} from './styles';

export const MobileMenu = ({ actions, title, subtitle, children }) => {
  const [show, setShow] = useState(false);

  const mobileMenuBodyRef = useRef(null);

  const openMenu = () => {
    setShow(true);
  };

  const closeMenu = () => {
    setShow(false);
  };

  const handleOutsideClick = e => {
    const mobileMenuBody = mobileMenuBodyRef.current;
    if (mobileMenuBody && !mobileMenuBody.contains(e.target)) {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const actionsList = actions.map((item, i) => (
    <StyledLink
      key={i}
      logout={item.logout}
      to={item.link}
      external={item.external}
      onClick={() => {
        TrackingHelper.track('LINK_CLICKED', {
          to: item.link,
          label: item.label,
        });
      }}
      dataTest={`mobile-menu__action-item${item.icon ? `--${item.icon}` : ''}`}
    >
      <StyledIconAction icon={item.icon} size={20} color="white" />
      <StyledLabel>{item.mobileLabel || item.label}</StyledLabel>
    </StyledLink>
  ));

  return (
    <StyledMobileMenu ref={mobileMenuBodyRef} data-test="mobile-menu">
      <StyledTrigger onClick={openMenu}>
        <StyledIconTrigger icon="mywallet-bars" size={24} color="white" />
        <div>Menu</div>
      </StyledTrigger>

      <StyledMobileMenuBody visible={show}>
        <StyledCancelTrigger onClick={closeMenu}>
          <StyledIconTrigger icon="cancel" size={24} color="white" />
        </StyledCancelTrigger>

        <StyledInfoContainer>
          <StyledPrimaryInfo>{title}</StyledPrimaryInfo>
          <StyledSecondaryInfo>{subtitle}</StyledSecondaryInfo>
        </StyledInfoContainer>

        <div>{actionsList}</div>

        {children && <div>{children}</div>}
      </StyledMobileMenuBody>
    </StyledMobileMenu>
  );
};

MobileMenu.propTypes = {
  actions: array.isRequired,
  title: string.isRequired,
  subtitle: oneOfType([string, bool]).isRequired,
  children: any,
};
